import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import "./BlockNewUser.css"

const AddBlockUser = ({ onClose }) => {
  const token = useSelector((store) => store.userReducer.token);
  const [loading, setLoading] = useState(false);
  const [searchType, setSearchType] = useState("orderId");


  return (
    <div className="block-modal-overlay">
      <div className="block-modal-content">
        <button onClick={onClose} className="block-modal-buttons-close">
          <FaTimes size={25} />
        </button>
        <h2>Add New Block User</h2>
        <form>
          <label htmlFor="keyword">Select Option :</label>
          <div className="flex-row">
            <div className="select-wrapper">
              <ReactSelect
                options={[
                  { value: "orderId", label: "Order Id" },
                  { value: "responseUTR", label: "UTR Id" },
                  { value: "transactionId", label: "Transaction Id" },
                  { value: "referenceId", label: "Reference Id" },
                ]}
                onChange={(selectedOption) => setSearchType(selectedOption.value)}
                defaultValue={{ value: "orderId", label: "Order Id" }}
              />
            </div>
            <input
              type="text"
              placeholder="input"
              className="keyword-input"
            />
          </div>
          <button
            className="block-modal-buttons"
            type="submit"
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Block"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBlockUser;
